import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createSysDictionary, deleteSysDictionary as _deleteSysDictionary, updateSysDictionary, findSysDictionary, getSysDictionaryList } from '@/api/sysDictionary'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
export default {
  name: 'SysDictionary',
  filters: {
    formatDate: function formatDate(time) {
      if (time !== null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool !== null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSysDictionaryList,
      dialogFormVisible: false,
      type: '',
      formData: {
        name: null,
        type: null,
        status: true,
        desc: null
      },
      rules: {
        name: [{
          required: true,
          message: '请输入字典名（中）',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请输入字典名（英）',
          trigger: 'blur'
        }],
        desc: [{
          required: true,
          message: '请输入描述',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getTableData();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    toDetile: function toDetile(row) {
      this.$router.push({
        name: 'dictionaryDetail',
        params: {
          id: row.ID
        }
      });
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;

      if (this.searchInfo.status === '') {
        this.searchInfo.status = null;
      }

      this.getTableData();
    },
    updateSysDictionary: function updateSysDictionary(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return findSysDictionary({
                  ID: row.ID
                });

              case 2:
                res = _context2.sent;
                _this2.type = 'update';

                if (res.code === 0) {
                  _this2.formData = res.data.resysDictionary;
                  _this2.dialogFormVisible = true;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        name: null,
        type: null,
        status: true,
        desc: null
      };
    },
    deleteSysDictionary: function deleteSysDictionary(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                row.visible = false;
                _context3.next = 3;
                return _deleteSysDictionary({
                  ID: row.ID
                });

              case 3:
                res = _context3.sent;

                if (res.code === 0) {
                  _this3.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this3.tableData.length === 1 && _this3.page > 1) {
                    _this3.page--;
                  }

                  _this3.getTableData();
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.$refs['elForm'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (valid) {
                              _context4.next = 2;
                              break;
                            }

                            return _context4.abrupt("return");

                          case 2:
                            _context4.t0 = _this4.type;
                            _context4.next = _context4.t0 === 'create' ? 5 : _context4.t0 === 'update' ? 9 : 13;
                            break;

                          case 5:
                            _context4.next = 7;
                            return createSysDictionary(_this4.formData);

                          case 7:
                            res = _context4.sent;
                            return _context4.abrupt("break", 17);

                          case 9:
                            _context4.next = 11;
                            return updateSysDictionary(_this4.formData);

                          case 11:
                            res = _context4.sent;
                            return _context4.abrupt("break", 17);

                          case 13:
                            _context4.next = 15;
                            return createSysDictionary(_this4.formData);

                          case 15:
                            res = _context4.sent;
                            return _context4.abrupt("break", 17);

                          case 17:
                            if (res.code === 0) {
                              _this4.closeDialog();

                              _this4.getTableData();
                            }

                          case 18:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    openDialog: function openDialog() {
      this.type = 'create';
      this.dialogFormVisible = true;
    }
  }
};